import { render, staticRenderFns } from "./form-scale-table.vue?vue&type=template&id=a9539ef0&scoped=true&"
import script from "./form-scale-table.vue?vue&type=script&lang=ts&"
export * from "./form-scale-table.vue?vue&type=script&lang=ts&"
import style0 from "./form-scale-table.vue?vue&type=style&index=0&id=a9539ef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9539ef0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
